module.exports = __webpack_public_path__ + "img/home.c003588c.png";